"use client"

import type React from "react"
import { useState } from "react"
import { JsonNode } from "./JsonNode"
import { Button } from "./ui/Button"
import { PlusCircle } from "./icons/PlusCircle"

interface JsonEditorProps {
  data: Record<string, any>
  onChange: (data: Record<string, any>) => void
}

export const JsonEditor: React.FC<JsonEditorProps> = ({ data, onChange }) => {
  const [newKey, setNewKey] = useState("")

  const handleAddProperty = () => {
    if (!newKey.trim()) {
      alert("Please enter a property name")
      return
    }

    if (data[newKey] !== undefined) {
      alert("Property already exists")
      return
    }

    onChange({
      ...data,
      [newKey]: "",
    })

    setNewKey("")
  }

  const handleUpdateProperty = (key: string, value: any) => {
    onChange({
      ...data,
      [key]: value,
    })
  }

  const handleRemoveProperty = (key: string) => {
    const newData = { ...data }
    delete newData[key]
    onChange(newData)
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <input
          type="text"
          value={newKey}
          onChange={(e) => setNewKey(e.target.value)}
          placeholder="New property name"
          className="flex-1 px-3 py-2 border border-gray-300 rounded-md"
        />
        <Button onClick={handleAddProperty} variant="primary">
          <PlusCircle className="w-4 h-4 mr-2" />
          Add
        </Button>
      </div>

      <div className="space-y-3">
        {Object.keys(data).length === 0 ? (
          <div className="text-gray-500 italic p-4 text-center border border-dashed border-gray-300 rounded-md">
            No properties yet. Add a property to get started.
          </div>
        ) : (
          Object.keys(data).map((key) => (
            <JsonNode
              key={key}
              propertyKey={key}
              value={data[key]}
              onChange={(value) => handleUpdateProperty(key, value)}
              onRemove={() => handleRemoveProperty(key)}
            />
          ))
        )}
      </div>
    </div>
  )
}
